<template>
  <!-- 系统目录 员工档案 -->
  <div class="box" id="rightCont">
    <!-- main -->
    <div class="main" id="main">
      <!-- left -->
      <!-- <div class="main-left"> -->
        <!-- <div class="tree">
          <el-tree
            :data="elTree" 
            :props="defaultProps"
            node-key="label"
            :default-expanded-keys="['全部']"
            accordion
            ref="tree"
            :filter-node-method="filterNode"
            @node-click="handleNodeClick"
            class="custom-tree"
            element-loading-spinner="el-icon-more-outline"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }" style="font-size: 12px;">
              <span :name="node.label">
                <i v-if="!data.children"
                  :class="node.expanded ? 'el-icon-bumenOpen' : 'el-icon-bumenClose'"></i>
                <i v-else class="el-icon-bumenOpen"></i>
                <span style="margin-left: 8px;">{{ node.label }}</span>
              </span>
            </span>
          </el-tree>
        </div> -->
      <!-- </div> -->
      <!-- right -->
      <div class="main-right">
        <div class="main-icon">
          <div class="main-icon-a">
            <i :class="iconComes" style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;;background-color: #409EFF;color: #fff;"></i>
            <span style="font-size: 14px;font-weight:300;margin-left: 12px;color: #606266;">{{ CatalogueName }}</span>
          </div>
          <!-- btn1 -->
          <div class="main-icon-zzgl">
            <span style="font-size: 12px;color: #606266;margin-left: 18px;">状态：</span>
            <el-dropdown @command="handleCommand" trigger="click">
              <span class="el-dropdown-link">{{ DropDownedName }}<i class="el-icon-down"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(v,i) in selecteds" :key="i" :command="v.command">{{ v.title }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- 搜索 -->
          <div class="main-icon-c">
            <span style="font-size: 12px;color: #606266;font-weight: bold;display: inline-block;width: 68px;">关键字：</span>
            <el-autocomplete  popper-class="my-autocomplete" v-model="searchValue" :fetch-suggestions="querySearch" placeholder="编码、员工姓名"
              size='mini' @select="handleSelect">
              <i class="el-icon-Ssearch" slot="suffix" style="cursor: pointer;margin-right: 8px;" @click="handleIconClick"></i>
              <template slot-scope="{ item }">
                <div class="name" style="font-size: 12px;">{{ item.fullName }}</div>
              </template>
            </el-autocomplete>
          </div>
          <!-- btn3 -->
          <div class="main-icon-c">
            <el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="mini" @click="handClick(i)">{{ v.title }}</el-button>
          </div>
        </div>
        <!-- table -->
        <div class="table">
          <el-table :data="tableData" @row-dblclick="handledbRow" border 
            :max-height="tableHeight" highlight-current-row @current-change="handleCurrentTableChange">
            <!-- 表格行下拉展示 -->
            <el-table-column type="expand" fixed="left">
              <template slot-scope="props">
                <div class="infos">
                  <div class="textDes">
                    <el-descriptions title="基本信息详情" :column="6" :size="size" border>
                      <el-descriptions-item>
                        <template slot="label"><i class="el-icon-user">员工姓名</i></template>{{props.row.fullName}}
                      </el-descriptions-item>
                      <el-descriptions-item>
                        <template slot="label"><i class="el-icon-phone">联系电话</i></template>{{props.row.contactNumber}}
                      </el-descriptions-item>
                      <el-descriptions-item>
                        <template slot="label"><i class="el-icon-location-outline">联系地址</i></template>{{props.row.contactAddress}}
                      </el-descriptions-item>
                      <el-descriptions-item>
                        <template slot="label"><i class="el-icon-location-outline">身份证号码</i></template>{{props.row.idNumber}}
                      </el-descriptions-item>
                      <el-descriptions-item>
                        <template slot="label"><i class="el-icon-location-outline">民族</i></template>
                        <el-tag size="small">{{ props.row.minZu }}</el-tag>
                      </el-descriptions-item>
                      <el-descriptions-item>
                        <template slot="label"><i class="el-icon-location-outline">政治面貌</i></template>
                        <span>{{ props.row.politicalStatus }}</span>
                      </el-descriptions-item>
                      <el-descriptions-item>
                        <template slot="label"><i class="el-icon-location-outline">工作证件</i></template>
                        <div class="imgUrl" style="width: 88px;height: 88px;">
                          
                        </div>
                      </el-descriptions-item>
                      <el-descriptions-item>
                        <template slot="label"><i class="el-icon-location-outline">手工签名</i></template>
                        <div class="imgUrl" style="width: 88px;height: 88px;">
                          
                        </div>
                      </el-descriptions-item>
                      <el-descriptions-item>
                        <template slot="label"><i class="el-icon-location-outline">资格证照</i></template>
                        <div class="imgUrl" style="width: 88px;height: 88px;">
                          
                        </div>
                      </el-descriptions-item>
                      <el-descriptions-item>
                        <template slot="label"><i class="el-icon-location-outline">执业证照</i></template>
                        <div class="imgUrl" style="width: 88px;height: 88px;">
                          
                        </div>
                      </el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- fixed -->
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column prop="userCode" sortable label="员工编号" width="128"></el-table-column>
            <el-table-column prop="fullName" sortable label="员工姓名" width="128">
              <template slot-scope="scope">
                <span :style="{color: scope.row.sex === '1' ? '#000039' : '#F56C6C'}"> {{ scope.row.fullName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sex" sortable label="性别" width="80">
              <template slot-scope="scope">
                <span>
                  <i :class="scope.row.sex === '1' ? 'el-icon-male' : 'el-icon-female'" 
                    :style="{color: scope.row.sex === '1' ? '#000039' : '#F56C6C'}"></i>
                  {{ scope.row.sex === '1' ? '男' : '女' }}
                </span>
              </template>
            </el-table-column>
            
            <!-- 身份证号列（脱敏显示） -->
            <el-table-column prop="idNumber" sortable label="身份证号" width="180">
              <template slot-scope="scope">
                <span>{{ showFullId ? scope.row.idNumber : maskIdNumber(scope.row.idNumber) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="minZu" sortable label="民族" width="88">
              <template slot-scope="{ row }">
                <span>{{ minZuMap[row.minZu] || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="professionalTitle" sortable label="专业职称" width="128">
              <template slot-scope="{ row }">
                <span>{{ professMap[row.professionalTitle] || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="politicalStatus" sortable label="政治面貌" width="128">
              <template slot-scope="{ row }">
                <span>{{ politicalMap[row.politicalStatus] || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="bloodType" sortable label="血型" width="88">
              <template slot-scope="{ row }">
                <span>{{ bloodTypeMap[row.bloodType] || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column v-for="(col, inx) in tableRows" sortable :key="inx" :type="col.type" :prop="col.prop" :label="col.name" :width="columnWidth(col, tableData)"></el-table-column>
            <el-table-column prop="prescriptionRights" label="处方权限" width="88">
              <template slot-scope="{ row }">
                <span>{{ TypeMap[row.prescriptionRights] || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="anesthesiaAuthorization" label="麻醉权限" width="88">
              <template slot-scope="{ row }">
                <span>{{ TypeMap[row.anesthesiaAuthorization] || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="surgicalPermission" label="手术权限" width="88">
              <template slot-scope="{ row }">
                <span>{{ TypeMap[row.surgicalPermission] || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="poisonPermission" label="毒药权限" width="88">
              <template slot-scope="{ row }">
                <span>{{ TypeMap[row.poisonPermission] || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="workIdPhoto" label="工作证件">
              <template slot-scope="{ row }">
                <div class="imgSize" style="width:28px;height:28px;display: flex;margin: auto;">
                  
                </div>
              </template>
            </el-table-column>
			<!-- 在表格操作列部分修改删除按钮，添加tooltip提示 -->
			<el-table-column fixed="right" label="操作" width="200" align="center">
			  <template slot-scope="scope">
			    <div class="action-buttons">
			      <!-- 详情按钮 - 一直启用 -->
			      <el-button 
			        type="text" 
			        size="mini" 
			        @click="handleDetail(scope.row)"
			        style="color: #409EFF;"
			      >
			        详情
			      </el-button>
			      
			      <!-- 修改按钮 - 根据权限启用/禁用 -->
			      <el-button 
			        type="text" 
			        size="mini" 
			        :disabled="!hasEditPermission"
			        @click="handleEdit(scope.row)"
			        :style="{ color: hasEditPermission ? '#E6A23C' : '#C0C4CC' }"
			      >
			        修改
			      </el-button>
			      
			      <!-- 删除按钮 - 一直禁用，添加tooltip提示 -->
			      <el-tooltip 
			        effect="dark" 
			        content="没有权限允许删除该员工信息！" 
			        placement="top"
			      >
			        <el-button 
			          type="text" 
			          size="mini" 
			          disabled
			          style="color: #C0C4CC;"
			        >
			          删除
			        </el-button>
			      </el-tooltip>
			    </div>
			  </template>
			</el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            style="margin: 12px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 50, 100]"
            :page-size="pageSize"
            :total="totalSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
          >
          </el-pagination>
        </div>
        <!-- feet -->
        <div class="feet" id="feet">
          <div class="feetBtn">
            <el-button v-for="(v,i) in feetBtn" :key="i" :type="v.type" :loading="loading"
			 :icon="v.icon" size="mini" @click="feetHandClick(v,i)"
			 v-if="$store.getters.hasPermission(v.auth)"
			 >{{ v.title }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- messagesBox -->
    <div class="addmessagesBox">
      <!-- <addAcc ref="addAcc" @childEvent="aa"></addAcc> -->
	   <!-- 新增员工对话框 -->
	   <addAcc
	     ref="addAcc"
	     :visible="addDialogVisible"
	     @close="addDialogVisible = false"
	     @update-success="handleUpdateSuccess"
	     @save="handleSaveEmployee"
	   />
    </div>
    <!-- 查看员工档案弹窗 -->
    <div class="watchAccBox">
      <WatchAccList 
        ref="watchAcc" 
        :visible="watchDialogVisible" 
        :employee-data="currentEmployeeData"
        @close="watchDialogVisible = false" 
      />
    </div>
    <div class="moreTool">
      <!-- 高级设置对话框 -->
      <el-dialog title="高级设置" :visible.sync="advancedDialogVisible" width="30%">
        <el-form label-width="120px">
          <el-form-item label="身份证显示模式">
            <el-switch
              :value="showFullId"
              active-text="完整显示"
              inactive-text="脱敏显示"
              @change="handleSwitchChange">
            </el-switch>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="advancedDialogVisible = false" size="mini">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// son 
import addAcc from "./addAcc.vue";
import WatchAccList from "./AccListSon/WatchAccList.vue";
// selfs / js
import Chinese from "@/external/PY.js";
import Pinyin from "@/external/pinyin.js";
// 接口
import { selectList, dict, updateStatus } from "@/api/staff/staff.js"
import { findAttribute , getStaff } from "@/api/user.js";

export default {
  watch: {
    showFullId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.handleIdDisplayChange(newVal);
      }
    }
  },
  components: {
    addAcc,
    WatchAccList
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
	  currentEmployeeData: {}, // 用于查看和编辑的当前员工数据
	  newEmployeeData: {},     // 用于新建的员工数据
	  deptOptions: [], // 添加科室选项数据
      // str
      watch:'查看',
      searchValue:'',
      status:1,
      tableHeight:'570',
      currentHeight:'',
      windowWidth: '',
      toCodeNum:'0000',
      iconHandleClick:'el-icon-plus',
      CatalogueName:'员工档案',
      elName:'',
      DropDownedName:'可用',
      typeValue:'',
      YNuseVaule:'可用',
      nowDateTimeValue:'',
      iconComes:'el-icon-dangan',
      operatingTime:'',
      // boolean
      disabled:true,
      noEidt:true,
      formdisabled:true,
      loading:false,
      dialogVisible:false,
      addDialogVisible:false,
      // number
      dataIndex: 0,
      CodeNumber:0,
      pageNum: 1,
      pageSize: 20,
      totalSize: 10,
      // arr
      data: [],
      oop:[],
      userInfo: [],
      watchData: [],
      tableData: [],
      currentTable:[],
      restaurants: [],
      showFullId: false,
      advancedDialogVisible: false,
      password: '',
      passwordError: false,
      selecteds:[ { title:"可用", command:"a" },{ title:"禁用", command:"b" } ],
      YNuse:[{ id:1,label:'可用',value:'1'},{ id:2,label:'禁用',value:'2'}],
      drugTypeOptions:[{ id:1,label:'毒麻类',value:'毒麻类'},{ id:2,label:'精神类',value:'精神类'}],
      elTree:[{ label: '全部', path:'', title:'', icon:'el-icon-news',children:[]}],
      PoliticalOptions:[
        {id: 1, label: "中共党员"},{id: 2,label: "中共预备党员"},{id: 3,label: "共青团员"},{id: 4,label: "民革党员"},
        {id: 5,label: "民盟盟员"},{id: 6, label: "民建会员"},{ id: 7,label: "民进会员"},{id: 8,label: "农工党党员"},
        {id: 9,label: "致公党党员"},{id: 10,label: "九三学社社员"},{id: 11,label: "台盟盟员"},{id: 12,label: "无党派人士"},{id: 13,label: "群众"},
      ],
      headerBtn:[
        { refesh:"refesh", title:"刷新", type:"", icon:"el-icon-refresh" },
        { senior:"senior", title:"高级", type:"primary", icon:"" },
      ],
      defaultButtons: [
            { title: "新建员工档案", type: "success", icon: "el-icon-adds", auth: 'system:staff:add' },
            { title: "修改员工档案", type: "warning", icon: "el-icon-edit", auth: 'system:staff:edit' },
            { title: "查看", type: "primary", icon: "el-icon-view", auth: 'system:staff:view' },
            { title: "关闭", type: "info", icon: "el-icon-close", auth: 'system:staff:close' }
          ],
      feetBtn: [],
      professionalOptions: [],
      minZuMap:{
        1: '数据不对，默认admin',
      },
      politicalMap:{
        1: '数据不对，默认admin',
      },
      bloodTypeMap:{
        1: '数据不对，默认admin',
      },
      professMap:{
        1: '数据不对，默认admin',
      },
      TypeMap:{
        '0': '否',
        '1': '是',
      },
	  deptOptionsBM:[],
	  xlOptions:[],
	  mjOptions:[],
      tableRows:[
        { name:"员工编码", prop:"userCode", nz:"nz" },
        { name:"出生日期", prop:"brdy", type:"" },{ name:"农历生日", prop:"lunarBrdy", type:"" },
        { name:"隶属科室", prop:"deptName", nz:"nz" },{ name:"执业证号", prop:"practicingNumber", type:"" },
        { name:"资格证书编号", prop:"qualificationNumber", type:"" },{ name:"贯标码", prop:"standardCode", type:"" },
        { name:"贯标名称", prop:"standardName", type:"" },
      ],
      // addDialogVisible: false ,// 添加新建对话框控制变量
	  watchDialogVisible: false // 添加查看对话框控制变量
    };
  },
  computed: {
    formattedNumber() {
      return '00000' + this.toCodeNum.toString().slice(1);
    },
	 // 检查是否有编辑权限
	  hasEditPermission() {
	    return this.$store.getters.hasPermission('system:staff:edit');
	  },
  },
  mounted() {
    this.loadData();
    this.$nextTick(()=>{
      this.getditc();
      this.updateWindowWidth();
      window.addEventListener('resize', this.updateWindowWidth);
      this.currentHeight = this.$getHeights();
      this.getTableHeight();
    })
    this.nowDateTime();
    this.initButtons();
  },
  methods: {
    // 打开新增对话框
    openAddDialog() {
      this.addDialogVisible = true;
    },

    // 处理保存员工
    async handleSaveEmployee(employeeData) {
      try {
        // 确保数据格式正确
        const formattedData = this.formatEmployeeData(employeeData);
        const res = await addStaff(formattedData);
        
        if (res.code === 200) {
          this.$message.success('员工添加成功');
          this.addDialogVisible = false;
          // 触发数据更新
          this.handleUpdateSuccess();
        } else {
          this.$message.error(res.message || '添加失败');
        }
      } catch (error) {
        console.error('保存失败:', error);
        this.$message.error('保存失败: ' + error.message);
      }
    },

    // 格式化员工数据
    formatEmployeeData(data) {
      return {
        status: '1',
        userCode: data.userCode || '',
        fullName: data.fullName || '',
        idType: data.idType || 1,
        idNumber: data.idNumber || '',
        sex: data.sex || '',
        birthDate: data.birthDate || '',
        lunarBirthDate: data.lunarBirthDate || '',
        minZu: data.minZu || '',
        nationality: data.nationality || 1,
        nativePlace: data.nativePlace || '',
        maritalStatus: data.maritalStatus || '',
        politicalStatus: data.politicalStatus || '',
        bloodType: data.bloodType || '',
        contactNumber: data.contactNumber || '',
        contactAddress: data.contactAddress || '',
        institutionId: data.institutionId || '',
        clinicId: data.clinicId || '',
        standardCode: data.standardCode || '',
        standardName: data.standardName || '',
        deptList: data.deptList || [],
        educationalBackground: data.educationalBackground || '',
        major: data.major || '',
        professionalTitle: data.professionalTitle || '',
        qualificationNumber: data.qualificationNumber || '',
        practiceDate: data.practiceDate || '',
        prescriptionRights: data.prescriptionRights || 0,
        chPrescriptionRights: data.chPrescriptionRights || 0,
        anesthesiaAuthorization: data.anesthesiaAuthorization || 0,
        surgicalPermission: data.surgicalPermission || 0,
        spiritPermission: data.spiritPermission || 0,
        poisonPermission: data.poisonPermission || 0,
        antiTumorPermission: data.antiTumorPermission || 0,
        roleId: data.roleId || [],
        signatureImage: data.signatureImage || '',
        workIdPhoto: data.workIdPhoto || '',
        pcElectronicImage: data.pcElectronicImage || '',
        qcElectronicImage: data.qcElectronicImage || ''
      };
    },

    // 修改 loadData 方法
    async loadData(){
      try {
        this.loading = true;
        let res = await selectList({
          status: this.status,
          fullName: this.searchValue,
          deptName: this.elName,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        });
        
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content.map(item => {
            return {
              ...item,
              showFullId: false
            }
          });
          this.restaurants = res.data.content;
        } else {
          this.$message.error(res.message || '加载数据失败');
        }
        
        // 加载科室数据
        let keDatas = await findAttribute();
        if (keDatas.code === 200) {
          this.elTree[0].children = keDatas.data.map(v => { 
            return { label: v.deptName, ...v };
          });
          
          // 同时更新 deptOptions
          this.deptOptions = keDatas.data.map(v => {
            return { 
              id: v.id, 
              label: v.deptName, 
              value: v.deptName, 
              specialtyName: v.specialtyName, 
              remark: v.remark 
            };
          });
        }
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$message.error('加载数据失败');
      } finally {
        this.loading = false;
      }
    },
    
    handleNodeClick(data,e) {
      this.CatalogueName = data.title || data.label;
      this.iconComes = 'el-icon-' + this.makePy(data.label);
      this.elName = data.label;
      this.loadData();
    },
    
    initButtons() {
      const currentPath = this.$route.path;
      const routeButtons = this.$getRouteButtons(currentPath);
      this.feetBtn = this.$mergeButtons(this.defaultButtons, routeButtons);
    },
    
    // 在 getditc() 方法中正确初始化 deptOptions
    async getditc(){
      try {
        this.result = await dict();
        localStorage.setItem('dict', JSON.stringify(this.result.data));
        
        // 初始化 deptOptions
        this.deptOptions = this.result.data.deptEntities?.map(v => { 
          return { label: v.deptName, ...v };
        }) || [];
        
        this.politicalMap = this.PoliticalOptions.reduce((map, item) => {
          map[item.id] = item.label;
          return map;
        }, { 1: '数据不对，默认admin' });
        
        this.idType = this.result.data.certypeEntities?.map(v => { 
          return { label: v.name, ...v };
        }) || [];
        
        this.professionalOptions = this.result.data.profttlEntities?.map(v => { 
          return { label: v.name, ...v };
        }) || [];
        
        this.professMap = this.professionalOptions.reduce((map, item) => {
          map[item.id] = item.label;
          return map;
        }, { 1: '数据不对，默认admin' });
        
        this.MZOptions = this.result.data.natyEntities?.map(v => { 
          return { label: v.name, ...v };
        }) || [];
        
        this.minZuMap = this.MZOptions.reduce((map, item) => {
          map[item.id] = item.label;
          return map;
        }, { 1: '数据不对，默认admin' });
        
        this.marryiedOptions = this.result.data.mrgStateEntities?.map(v => { 
          return { label: v.name, ...v };
        }) || [];
        
        this.bloodOptions = this.result.data.aboTypeEntities?.map(v => { 
          return { label: v.name, ...v };
        }) || [];
        
        this.bloodTypeMap = this.bloodOptions.reduce((map, item) => {
          map[item.id] = item.label;
          return map;
        }, { 1: '数据不对，默认admin' });
        
        this.bloodOptions = this.bloodOptions.filter(item =>
          item.name !== 'RH阳性' && item.name !== 'RH阴性'
        );
      } catch (error) {
        console.error('获取字典数据失败:', error);
        // 设置默认的 deptOptions
        this.deptOptions = [];
      }
    },
    
    aa(){
      // this.loadData();
    },
    // 处理详情按钮点击
	handleDetail(row) {
        console.log('查看详情:', row);
        this.currentEmployeeData = row;
        this.watchDialogVisible = true;
        
        // 调用查看组件的方法
        if (this.$refs.watchAcc) {
          this.$refs.watchAcc.openWatchModel(row.id);
        }
	},
    maskIdNumber(idNumber) {
      if (!idNumber || idNumber.length < 8) return idNumber;
      const prefix = idNumber.substring(0, 3);
      const suffix = idNumber.substring(idNumber.length - 4);
      return `${prefix}${'*'.repeat(idNumber.length - 7)}${suffix}`;
    },
    
    handleAdvancedClick() {
      this.advancedDialogVisible = true;
    },
    
    handleSwitchChange(newValue) {
      if (newValue) {
        this.$confirm('显示完整身份证号需要验证身份，请输入密码：', '验证身份', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'password',
          inputPlaceholder: '请输入密码',
          showInput: true,
          beforeClose: (s, instance, done) => {
            if (s === 'confirm') {
              if (instance.inputValue === '123456') {
                this.showFullId = true;
                done();
              } else {
                this.$message.error('密码错误');
                done();
                return false;
              }
            } else {
              done();
            }
          }
        }).catch(() => {});
      } else {
        this.showFullId = false;
      }
    },
    
    tableRowClassName({row}) {
      return row.status === '0' ? 'disabled-row' : '';
    },
    
    handleCurrentTableChange(val){
      this.currentTable = val
    },
    
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 888 * Math.random());
    },
    
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.fullName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    
    handleIconClick(ev) {
      this.loadData();
    },
    
    handleSelect(item) {
      this.searchValue = item.fullName
      this.loadData();
    },
    
    getTableHeight(){
      let headerHeight = this.currentHeight.mainHeight
      let feetHeight = this.currentHeight.feetHeight
      let lastHeight = this.currentHeight.lastHeight
      this.tableHeight = this.currentHeight.rightContentHeight - feetHeight * 3
    },
    
    columnWidth(col, list) {
      let prop = col.prop,lab = col.lab;
      let width = 40;
      let maxlenStr = "";
      for (let info of list) {
        if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
      }
      width = Math.max(width, len(lab), len(maxlenStr));
      return width + 12;
      
      function len(str) {
        let length = 18;
        for (const char of str + "") {
          if ("a" <= char && char <= "z") length += 8;
          else if ("A" <= char && char <= "Z") length += 8;
          else if (char >= "\u4e00" && char <= "\u9fa5") length += 18;
          else length += 8;
        }
        return length;
      }
    },
    
    addNewData(){
      this.$refs.addForm.validate(async(valid) => {
        if(valid){
          try {
            let res = await addPoisonAnesthesia(this.addForm)
            if (res.code === 200){
              this.$message({
                message:res.message,
                type:"success"
              });
              this.loadData();
            }
          } catch (error) {
            console.error('新增失败:', error);
          }
        }
      });
    },
    
    handlePrint() {
      this.$confirm('请选择打印方式', '打印设置', {
        confirmButtonText: 'Lodop打印',
        cancelButtonText: '浏览器打印',
        type: 'warning'
      }).then(() => {
        this.printWithLodop();
      }).catch(() => {
        console.log('用户选择浏览器打印');
      })
    },
    
    printWithLodop() {
      const tableData = this.tableData.map(item => {
        return {
          ...item,
        };
      });
      
      const currentTable = this.currentTable;
      
      this.$router.push({
        path: '/PrintTemplateDesigner',
        query: {
          tableData: JSON.stringify(tableData),
          currentTable: JSON.stringify(tableData),
          templateName: this.CatalogueName
        }
      });
    },
    
    inputLabel(){
      this.addForm.code = this.makePy(this.addForm.label).toLocaleUpperCase().slice(0,1) + this.formattedNumber + this.CodeNumber;
      this.addForm.textSpell = this.makePy(this.addForm.label).toLocaleUpperCase();
    },
    
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.formdisabled = true;
          done();
        })
        .catch(_ => {
          this.formdisabled = this.formdisabled;
        });
    },
    
    handledbRow(row, column, event){
      if(row){ 
        row.nameTitle = '查看'
        this.$refs.addAcc.openModel(row);
      }
      this.formdisabled = true
      this.form.textSpell = this.makePy(this.form.label).toLocaleUpperCase()
    },
    
    handClick(i) {
      switch (i) {
        case 0:
          this.loading = true;
          setTimeout(() => {
            this.loadData();
            this.loading = false;
          }, 1500)
          break;
        case 1:
          this.handleAdvancedClick();
          break;
      }
    },
    
    handleCommand(command) {
      switch (command) {
        case 'a':
          this.DropDownedName = '可用';
          this.status = 1;
          this.loadData();
          break;
        case 'b':
          this.DropDownedName = '禁用';
          this.status = 0;
          this.loadData();
          break;
      }
    },
    
    handleSizeChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    
    updateWindowWidth() {
      this.windowWidth = window.innerWidth - 288;
    },
    
    nowDateTime(){
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();
      const currentDate = `${year}-${month}-${day}`.replace(/-/g, '')
      this.nowDateTimeValue = `${year}-${month}-${day}` + ` ` + `${hours}:${minutes}:${seconds}`
    },
    
    // 在 methods 中添加处理新建和查看的方法
    async feetHandClick(v) {
      console.log(v);
      
      if (v.title == '新建' || v.title.includes('新建') || v.title.includes('新增')) {
        this.handleNewEmployee();
      }
      else if (v.title == '修改' || v.title.includes('修改') || v.title.includes('编辑')) {
        if (this.currentTable) {
          this.handleEditEmployee();
        } else {
          this.$message({ type: 'warning', message: '请先选择一条数据'});
        }
      }
      else if (v.title == '查看' || v.title.includes('查看') || v.title.includes('查看')) {
        if (this.currentTable) {
          this.handleViewEmployee();
        } else {
          this.$message({ type: 'warning', message: '请先选择一条数据'});
        }
      }
      else if (v.title === '打印') {
        this.handlePrint();
      }
      else if (v.title === '导出') {
        this.$confirm('敬请期待')
          .then(_ => {})
          .catch(_ => {});
      }
      else {
        setTimeout(() => {
          window.history.back();
        }, 888);
      }
    },
    
    // 处理新建员工
    handleNewEmployee() {
      this.nameTitle = '新建';
      this.newEmployeeData = this.getDefaultEmployeeData();
      this.addDialogVisible = true;
    },
    // 处理修改按钮点击
      handleEdit(row) {
        console.log('修改员工:', row);
        this.currentEmployeeData = row;
        
        // 调用编辑组件的方法
        if (this.$refs.addAcc) {
          this.$refs.addAcc.openEditModel(row.id);
          this.addDialogVisible = true;
        }
      },
    // 处理查看员工
    handleViewEmployee() {
      try {
		if (!this.currentTable || !this.currentTable.id) {
		  this.$message.error('请先选择一条有效的数据');
		  return;
		}
		
		this.loading = true;
		
		// 只传递ID给子组件，由子组件调用接口
		this.$refs.watchAcc.openWatchModel(this.currentTable.id);
		// this.addDialogVisible = true;
	  } catch (error) {
			console.error('编辑员工数据出错:', error);
			this.$message.error('编辑员工数据出错');
	  } finally {
			this.loading = false;
	  }
    },
    
    // 处理编辑员工
	async handleEditEmployee() {
	  try {
		if (!this.currentTable || !this.currentTable.id) {
		  this.$message.error('请先选择一条有效的数据');
		  return;
		}
		
		this.loading = true;
		
		// 只传递ID给子组件，由子组件调用接口
		this.$refs.addAcc.openEditModel(this.currentTable.id);
		this.addDialogVisible = true;
	  } catch (error) {
		console.error('编辑员工数据出错:', error);
		this.$message.error('编辑员工数据出错');
	  } finally {
		this.loading = false;
	  }
	},
    
    // 获取默认员工数据
    getDefaultEmployeeData() {
      return {
        status: '1',
        userCode: this.generateNextUserCode(),
        fullName: '',
        idType: 1,
        idNumber: '',
        sex: '',
        birthDate: '',
        lunarBirthDate: '',
        minZu: '',
        nationality: 1,
        nativePlace: '',
        maritalStatus: '',
        politicalStatus: '',
        bloodType: '',
        contactNumber: '',
        contactAddress: '',
        institutionId: '',
        clinicId: this.getCurrentClinicId(),
        standardCode: '',
        standardName: '',
        deptList: [],
        educationalBackground: '',
        major: '',
        professionalTitle: '',
        qualificationNumber: '',
        practiceDate: '',
        prescriptionRights: 0,
        chPrescriptionRights: 0,
        anesthesiaAuthorization: 0,
        surgicalPermission: 0,
        spiritPermission: 0,
        poisonPermission: 0,
        antiTumorPermission: 0,
        roleId: [],
        signatureImage: '',
        workIdPhoto: '',
        pcElectronicImage: '',
        qcElectronicImage: ''
      };
    },
    
	// 处理更新成功
	handleUpdateSuccess() {
	  // 重新加载数据
	  this.loadData();
	  // 可以添加其他更新逻辑
	  this.$message.success('数据更新成功');
	},
    // 生成下一个工号
    generateNextUserCode() {
      if (this.tableData && this.tableData.length > 0) {
        const maxCode = Math.max(...this.tableData.map(user => {
          const code = parseInt(user.userCode || '0');
          return isNaN(code) ? 0 : code;
        }));
        return (maxCode + 1).toString().padStart(3, '0');
      }
      return '001';
    },
    
    // 获取当前诊所ID
    getCurrentClinicId() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      return userInfo.clinicId || '';
    },
      
    // 添加一个方法来设置员工数据（可选，可以通过ref调用）
    setWatchEmployeeData(employeeData) {
        this.currentEmployeeData = employeeData;
        this.watchDialogVisible = true;
    },
    
    // 添加一个方法来设置员工数据（可选，可以通过ref调用）
    setAddEmployeeData(AddemployeeData) {
        this.currentAddEmployeeData = AddemployeeData;
        this.addDialogVisible = true;
    },
    
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    
    handleUpdateData(updatedData) {
      updateStaff(updatedData).then(res => {
        if(res.code === 200) {
          this.$message.success('修改成功')
          this.loadData()
        }
      })
    },
    
    makePy(str) {
      // 拼音转换逻辑
      if (!str) return '';
      return Pinyin.getFullChars(str) || '';
    },
    
    handleIdDisplayChange(newVal) {
      // 身份证显示模式变化处理
      console.log('身份证显示模式:', newVal ? '完整显示' : '脱敏显示');
    }
  }
};
</script>

<style lang="less" scoped>
.box {
  height: calc(100vh - 90px);
  width: 100%;
  overflow: hidden;

  /deep/ .el-table {
    width: 100% !important;
    
    .el-table__body-wrapper {
      overflow-x: auto !important;
    }
    
    .el-table__header-wrapper {
      overflow-x: hidden !important;
    }
    
    .el-icon-watch {
      color: #409EFF;
      &:hover {
        color: #66b1ff;
      }
    }
    .el-icon-shield {
      color: #F56C6C;
      &:hover {
        color: #f78989;
      }
    }
  }
  
  /deep/ .el-switch__label *{
    font-size: 12px;
  }
  
  /deep/ .el-table .cell{
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  
  /deep/ .el-table th{
    font-size: 12px;
    background-color: #f1f1f1;
    border: none;
    color: #2d2d2d;
  }
  
  /deep/ .el-table {
    width: 100%;
    
    .el-table__body-wrapper {
      overflow-x: hidden;
    }
  }
  
  ::v-deep .el-table__body tr.current-row > td {
    background-color: #80b7ff !important;
    color: #f9f9f9;
  }
  
  .main {
    display: flex;
    height: 100%;
    width: 100%;

    .main-left {
      width: 128px;
      height: 100%;
      background: #f5f7fa;
      border-right: 1px solid #e6e6e6;
      overflow-y: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      
      &::-webkit-scrollbar {
        display: none;
      }
    
      /deep/ .el-tree {
        height: 100%;
        .el-tree-node__content {
          height: 36px;
        }
      }
      
      /deep/ .tree .el-tree-node {
        position: relative;
      }
      
      /deep/ .tree .el-tree-node :last-child:before {
        height: 38px;
      }
      
      /deep/ .tree .el-tree > .el-tree-node:before {
        border-left: none;
      }
      
      /deep/ .tree .el-tree-node__children .el-tree-node:before {
        content: '';
        left: 12px;
        position: absolute;
        right: auto;
        border-width: 1px;
      }
      
      /deep/ .tree .el-tree-node__children {
        padding-left: 0px;
      }
      
      /deep/ .tree .el-tree-node:after {
        content: '';
        left: 12px;
        position: absolute;
        right: auto;
        border-width: 1px;
      }
      
      /deep/ .tree .el-tree-node__expand-icon.is-leaf {
        display: none;
      }
      
      /deep/ .tree .el-tree-node:before {
        border-left: 1px dashed #dddddd;
        bottom: 0px;
        height: 100%;
        top: -26px;
        width: 1px;
      }
      
      /deep/ .tree .el-tree-node:after {
        border-top: 1px dashed #dddddd;
        height: 20px;
        top: 12px;
        width: 24px;
      }
    }
    
    .main-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: hidden;
      
      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;
        
        .main-icon-a{
          // 样式
        }
        
        .main-icon-b{
          margin-left: 28px;
          /deep/ .el-dropdown{
            font-size: 12px;
            cursor: pointer;
          }
          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }
        }
        
        .main-icon-c{
          display: flex;
          align-items: center;
          margin-left: 28px;
          /deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b]{
            width: 80%;
          }
        }
      }
      
      .table {
        flex: 1;
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        
        /deep/ .el-pagination {
          margin: 12px;
        }
      }
      
      .feet {
        height: 40px;
        display: flex;
        align-items: center;
        padding: 12px;
        background: #fff;
        border-top: 1px solid #e6e6e6;
        flex-shrink: 0;
        
        .feetBtn {
          gap: 8px;
        }
      }
    }
  }
  
  .moreTool{
    /deep/ .el-dialog__header {
      background-color: #007bb0;
      padding: 12px;
    }
    
    /deep/ .el-dialog__title {
      color: #fff;
      font-size: 14px;
    }
    
    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }
    
    /deep/ .el-dialog__headerbtn .el-dialog__close:hover {
      background-color: brown;
    }
  }
  
  .addModel, .editModel {
    /deep/ .el-dialog__header{
      padding: 12px;
      line-height: 28px;
      background-color: #007bb0;
    }
    
    /deep/ .el-dialog__title{
      color: #fff;
      font-size: 12px;
    }
    
    /deep/ .el-dialog__headerbtn .el-dialog__close{
      color: #fff;
    }
    
    /deep/ .el-dialog__headerbtn .el-dialog__close:hover{
      background-color: brown;
    }
    
    /deep/ .el-form-item__label{
      font-size: 12px;
    }
  }
}
</style>